import { HttpModels } from './api/http.models';
import { ClientModels } from './client.models';
import { CommonModels } from './common.models';
import { PolicyModels } from './policy.models';
import Client = ClientModels.Client;

interface Job {
  assignToMe?: boolean;
  id: number;
  emailMessageId: number;
  payload?: any;
  statusId: number;
  statusReason?: any;
  creationDateTime: Date;
  modifiedDateTime: Date;
  accountId?: number;
  agencyId?: number;
  agency: string;
  client?: Client;
  clientId?: number;
  unAssign?: boolean;
}

export interface EmailEvents {
  id: number;
  payload: object;
  creationDateTime: Date;
  account: string;
}

export enum TemplateType {
  Email = 1,
  Courrier,
}

export namespace EmailModels {
  import BlobInfoResponse = HttpModels.BlobInfoResponse;
  import InsuranceTypeEnum = CommonModels.InsuranceTypeEnum;
  import TerminationTypeEnum = PolicyModels.TerminationTypeEnum;

  export interface EmailTableRow {
    id: number;
    from: string;
    hasAttachments: boolean;
    subject: string;
    to: string;
    receivedDateTime: Date;
  }

  export interface EmailMessage {
    bccs?: string;
    brokerVisible?: boolean;
    isTransfer?: boolean;
    emailTemplateId?: number;
    modifiedDateTime?: Date;
    emailMessageQueueId?: number;
    emailMessageQueue?: string;
    statusId?: number;
    agency?: string;
    agencyId?: number;
    policyId?: number;
    clientId?: number;
    client?: string;
    id?: number;
    subject?: string;
    sourceId?: string;
    content?: string;
    from?: string;
    to?: string[];
    tos?: string;
    ccs?: string;
    receivedDateTime?: Date;
    hasAttachments?: boolean;
    attachments?: Attachment[];
    isNew?: boolean;
    job?: Job;
    parentId?: number;
    policyPublicId?: string;
    emailType?: number;
    creationDateTime?: Date;
    emailEvents?: EmailEvents[];
    insuranceType?: InsuranceTypeEnum;
    accountName?: string;
    isVip?: boolean;
    files?: File[];
    isFromFile?: boolean;
  }

  export interface Attachment {
    documentType?: number;
    transfertToPolicy?: boolean;
    name: string;
    id: number;
    fileServiceModel?: BlobInfoResponse;
  }

  export enum EmailTemplateEnum {
    Open = 1,
    Unpaid = 2,
    AcceptationSansEffet = 3,
    RefusSansEffet = 4,
  }

  export interface EmailTemplate {
    id: number;
    lastModified: Date;
    name: string;
    subject: string;
    content: string;
    emailTemplateCategory: EmailTemplateCategory;
    insuranceType?: InsuranceTypeEnum;
    emailTemplateCategoryVal: string;
    terminationType: TerminationTypeEnum;
    registerLetter: boolean;
  }

  export interface EmailTemplateData {
    subject: string;
    body: string;
  }

  export enum JobStatusEnum {
    Submitted = 1,
    InProgress = 2,
    Processed = 3,
    Validated = 4,
    Rejected = 5,
    InError = 6,
    Sent = 7,
  }

  export enum EmailTemplateCategory {
    SansEffet = 1,
    Resiliation = 2,
    Avenant = 3,
    AckSansEffetResilClient,
    InstanceCourtier,
    InstanceClient,
    Autre,
    Signature,
    Header,
  }

  export enum FluxTypeEnum {
    Entrant = 1,
    Sortant = 2,
    Stock,
  }

  export enum EmailTypeEnum {
    WelcomeBroker = 1,
    LostPassword,
    AgencyReply,
    AckToBrokerContact,
    BrokerContract,
    ClientAutomobileQuotation,
    ClientAutomobileAttestation,
    AgencyEmail,
    PolicyNoticeToBroker,
    AckImsOfSinister,
    CustomerPaymentFileNotification,
    CustomerRefundFileNotification,
    HealthCreditCardPaymentNotification,
    WelcomeHandlingBroker,
    CustomerRefundChequeLetterFileNotification,
    RopQuotationFiles,
    RopPolicyFiles,
    RopSignatureOrder,
    AutoSignatureOrder,
    Relance,
    FinGarantieProvisoire,
  }

  export enum EmailQueueEnum {
    NotCategorized = 0,
    Résiliations = 1,
    Sanseffet,
    Cartedetierspayant,
    Remboursement,
    Avenanttarifaire,
    Avenantnontarifaire,
    ChangementdeRIB,
    Cotisation,
    DemandeCourtier,
    Réclamation,
    Reportdedate,
    Retoursdepièces,
    Télétransmission,
    AvenantChangementVehicule,
    AvenantChangementFractionnement,
  }
}
